// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .user-info-table {
    width: 90%;
    border-collapse: collapse;
    margin-top: 25px;
    margin-left:100px;
    align-items: center;
  }
  
  .user-info-table th, .user-info-table td {
    border: 1px solid #d9a6a6;
    padding: 8px;
  }
  
  .user-info-table th {
     background-color: #d9e715; 

    text-align: center;
  }
   
  .header-container {
    margin-top: 20px;
    text-align: center; 
  }
  
  .header-container h2,
  .header-container button {
    display: inline-block; 
    vertical-align: middle; 
  }
  
  .header-container h2 {
    margin-left: 150px;
    
  }
  
  .header-container button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    margin-left: 300px;
    
  }
  
  .header-container button:hover {
    background-color: #45a049;
  }
  
  .user-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
   
   .user-search-bar {
    position: relative;
    display: flex;
    margin-left:100px;
    align-items: center;
    width: 20%; 
  }
  
  .search-input {
    padding: 10px 15px 10px 40px; 
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
  }
  
  .search-icon {
    position: absolute;
    left : 90px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #1d2adf;
    pointer-events: none; 
  }
  
   
  .search-button {
    background-color: #4CAF50;
    color: white;
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .search-button:hover {
    background-color: #45a049;
  }
  
  .search-button:focus {
    outline: none;
  }
   
  .user-create {
    background-color: #4CAF50;
    color: white;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    display: flex;
    margin-right:50px;
    align-items: center;
    font-size: 16px;
    border-radius: 5px;
  }
  
  .user-create:hover {
    background-color: #37a305;
  }
 
  


/* Modal container */
.user-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}


.user-modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.success-message {
  color: green;
  font-size: 16px;
  margin-top: 10px;
  position: fixed; 
  top: 20px; 
  left: 50%; 
  transform: translateX(-50%);
  z-index: 9999; 
  background-color: #fff; 
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.user-form-group {
  display: flex;
  align-items: center;
  margin-bottom: 15px; 
}

.user-form-group label {
  font-weight: bold;
  margin-right: 10px; 
  width: 30%; 
}

.user-form-group input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 70%; 
  box-sizing: border-box;
}
.user-form-group select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 75%; 
  box-sizing: border-box;
}

.user-modal-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.user-modal-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}


.user-modal-buttons button:first-child {
  background-color: #007bff;
  color: white;
}

.user-modal-buttons button:last-child {
  background-color: #d22525;
  color: rgb(245, 241, 241);
}

`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/UserInfoTable.css"],"names":[],"mappings":"CAAC;IACG,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;KACG,yBAAyB;;IAE1B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;;EAEpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;;GAGC;IACC,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;EACtB;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;;;;AAKF,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B","sourcesContent":[" .user-info-table {\r\n    width: 90%;\r\n    border-collapse: collapse;\r\n    margin-top: 25px;\r\n    margin-left:100px;\r\n    align-items: center;\r\n  }\r\n  \r\n  .user-info-table th, .user-info-table td {\r\n    border: 1px solid #d9a6a6;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .user-info-table th {\r\n     background-color: #d9e715; \r\n\r\n    text-align: center;\r\n  }\r\n   \r\n  .header-container {\r\n    margin-top: 20px;\r\n    text-align: center; \r\n  }\r\n  \r\n  .header-container h2,\r\n  .header-container button {\r\n    display: inline-block; \r\n    vertical-align: middle; \r\n  }\r\n  \r\n  .header-container h2 {\r\n    margin-left: 150px;\r\n    \r\n  }\r\n  \r\n  .header-container button {\r\n    padding: 8px 16px;\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    margin-left: 300px;\r\n    \r\n  }\r\n  \r\n  .header-container button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .user-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n  }\r\n  \r\n   \r\n   .user-search-bar {\r\n    position: relative;\r\n    display: flex;\r\n    margin-left:100px;\r\n    align-items: center;\r\n    width: 20%; \r\n  }\r\n  \r\n  .search-input {\r\n    padding: 10px 15px 10px 40px; \r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    outline: none;\r\n  }\r\n  \r\n  .search-icon {\r\n    position: absolute;\r\n    left : 90px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    font-size: 16px;\r\n    color: #1d2adf;\r\n    pointer-events: none; \r\n  }\r\n  \r\n   \r\n  .search-button {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .search-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .search-button:focus {\r\n    outline: none;\r\n  }\r\n   \r\n  .user-create {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    padding: 8px 16px;\r\n    border: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    margin-right:50px;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .user-create:hover {\r\n    background-color: #37a305;\r\n  }\r\n \r\n  \r\n\r\n\r\n/* Modal container */\r\n.user-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n\r\n.user-modal-content {\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  width: 400px;\r\n  max-width: 90%;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.success-message {\r\n  color: green;\r\n  font-size: 16px;\r\n  margin-top: 10px;\r\n  position: fixed; \r\n  top: 20px; \r\n  left: 50%; \r\n  transform: translateX(-50%);\r\n  z-index: 9999; \r\n  background-color: #fff; \r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.user-form-group {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 15px; \r\n}\r\n\r\n.user-form-group label {\r\n  font-weight: bold;\r\n  margin-right: 10px; \r\n  width: 30%; \r\n}\r\n\r\n.user-form-group input {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 70%; \r\n  box-sizing: border-box;\r\n}\r\n.user-form-group select {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 75%; \r\n  box-sizing: border-box;\r\n}\r\n\r\n.user-modal-buttons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 20px;\r\n}\r\n\r\n.user-modal-buttons button {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.user-modal-buttons button:first-child {\r\n  background-color: #007bff;\r\n  color: white;\r\n}\r\n\r\n.user-modal-buttons button:last-child {\r\n  background-color: #d22525;\r\n  color: rgb(245, 241, 241);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
